import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';

const Footer = () => {
  const footerLinks = [
    { title: "About Noilio", href: "#" },
    { title: "Community", href: "#" },
    { title: "Careers", href: "#" },
    { title: "Contact Us", href: "#" }
  ];

  return (
    <footer className="py-16 px-4 border-t border-white/10">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo and Tagline */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="mb-8 md:mb-0 text-center md:text-left"
          >
            <div className="mb-2">
              <img 
                src="/Noilio Logo-white.svg" 
                alt="Noilio" 
                className="h-10 w-auto mx-auto md:mx-0"
              />
            </div>
            <p className="text-white/60 text-sm">
              Where Nollywood Lives.
            </p>
          </motion.div>

          {/* Navigation Links */}
          <motion.nav
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex flex-wrap justify-center gap-8 mb-8 md:mb-0"
          >
            {footerLinks.map((link, index) => (
              <motion.a
                key={index}
                href={link.href}
                whileHover={{ scale: 1.05 }}
                className="text-white/70 hover:text-white transition-colors duration-300"
              >
                {link.title}
              </motion.a>
            ))}
          </motion.nav>

          {/* Made with Love */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
            className="text-center md:text-right"
          >
            <p className="text-white/50 text-sm flex items-center justify-center md:justify-end gap-2">
              Made with <Heart size={16} className="text-primary-coral fill-current" /> for Nollywood
            </p>
          </motion.div>
        </div>

        {/* Bottom Border */}
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
          viewport={{ once: true }}
          className="mt-12 h-px bg-gradient-to-r from-transparent via-white/20 to-transparent"
        />
        
        {/* YouTube hosting notice */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true }}
          className="mt-8 text-center"
        >
          <p className="text-white/50 text-sm max-w-2xl mx-auto">
            All videos are officially hosted on YouTube. Noilio curates, organizes, and enhances the Nollywood viewing experience.
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer; 